// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__2K6YZ","icon":"style_icon__1lW-c","title":"style_title__2y8oq"};